import * as React from 'react';
import {Helmet} from 'react-helmet';
import {RecipeBuilder} from 'components/RecipeBuilder';
import {useRoute} from 'react-router5';
import useLoading from '../../hooks/use-loading';
import {RecipeObject} from '../../api/recipe/types';
import {editRecipe, getRecipe} from '../../api/recipe/requests';
import validateResponse from '../../helpers/validate-response';
import isError from '../../helpers/isError';
import {toast} from 'react-toastify';

/**
 * Edit the recipe page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function EditRecipe(): React.ReactElement {
  const {data, fetch, render} = useLoading<RecipeObject>();
  const {route, router} = useRoute();

  React.useEffect(() => {
    fetch(() => new Promise((resolve) => (
      getRecipe(route.params.recipeId).then((response) => {
        validateResponse(response);

        if (response && !isError(response)) {
          resolve(response);
        }
      })
    )))
  }, [route.params.recipeId]);

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return (
      <RecipeBuilder
        defaultValue={data}
        onUpdate={(recipe) => (
          editRecipe(recipe).then((response) => {
            validateResponse(response);

            if (response && !isError(response)) {
              toast.success('Рецепт обновлен');
              router.navigate('recipes');
            }
          })
        )}
      />
    );
  }

  /**
   * Render not found.
   * @return {JSX.Element}
   */
  function renderNotFound(): JSX.Element {
    return (
      <React.Fragment />
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>FitPlace / Редактировать упражнение</title>
      </Helmet>
      {render(renderContent, renderNotFound)}
    </React.Fragment>
  );
}
